import { render, staticRenderFns } from "./DocumentMoney.vue?vue&type=template&id=6b44f496&"
import script from "./DocumentMoney.vue?vue&type=script&lang=js&"
export * from "./DocumentMoney.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMoney.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports